<script lang="ts" setup>
import HomepageGetListed from '~/components/homepage/HomepageGetListed.vue';
import HomepageWhyJoinAsServiceProvider from '~/components/homepage/HomepageWhyJoinAsServiceProvider.vue';
import HomepageProcessesGalerie from '~/components/homepage/HomepageProcessesGalerie.vue';
import HomepageExploreServiceProvider from '~/components/homepage/HomepageExploreServiceProvider.vue';
import HomepageBottomLinks from '~/components/homepage/HomepageBottomLinks.vue';
import HomepageHowItWork from '~/components/homepage/HomepageHowItWork.vue';
import HomepageSocial from '~/components/homepage/HomepageSocial.vue';

import Footer from '~/components/Footer.vue';

import { useTranslations } from '~/composables/translations';
import { useSettingsStore } from '~/stores/settings';
import { computed } from 'vue';
import { useRouter } from 'vue-router';

const { $i18n: $i18nPF } = useTranslations('process_families');

const router = useRouter();
const settings = useSettingsStore();

const processes = computed(() => [
  {
    name: $i18nPF('3d_printing'),
    icon: 'manufacturing-additive',
    wiki: '3D-printing',
    trackerEvent: {
      iconLabel: 'HOME_ABVFOLD_3DPPROCESSICON_BTN_CLICK_',
      btnLabel: 'HOME_ABVFOLD_3DPGETAQUOTE_BTN_CLICK_',
    },
    image: 'processes_3Dprinting.webp',
    id: 'PF-1e81bc36e0676bc29f33f45c89bf7ac9',
  },
  {
    name: $i18nPF('cnc_machining'),
    icon: 'manufacturing-substractive',
    wiki: 'CNC-machining',
    trackerEvent: {
      iconLabel: 'HOME_ABVFOLD_CNCPROCESSICON_BTN_CLICK_',
      btnLabel: 'HOME_ABVFOLD_CNCGETAQUOTE_BTN_CLICK_',
    },
    image: 'processes_CNCmachining.webp',
    id: 'PF-1e81bc39b8c16c97bff9f45c89bf7ac9',
  },
  {
    name: $i18nPF('sheet_metal'),
    icon: 'manufacturing-forming',
    wiki: 'forming',
    trackerEvent: {
      iconLabel: 'HOME_ABVFOLD_SHEETPROCESSICON_BTN_CLICK_',
      btnLabel: 'HOME_ABVFOLD_SHEETGETAQUOTE_BTN_CLICK_',
    },
    image: 'processes_sheetMetal.webp',
    id: 'PF-1e81bc3c88696e11870df45c89bf7ac9',
  },
  {
    name: $i18nPF('cutting'),
    icon: 'manufacturing-cutting',
    wiki: 'cutting',
    trackerEvent: {
      iconLabel: 'HOME_ABVFOLD_CUTPROCESSINCON_BTN_CLICK_',
      btnLabel: 'HOME_ABVFOLD_CUTGETAQUOTE_BTN_CLICK_',
    },
    image: 'processes_laserCutting.webp',
    id: 'PF-1e81bc3b8e406dd1a552f45c89bf7ac9',
  },
  {
    name: $i18nPF('injection_molding'),
    icon: 'manufacturing-molding',
    wiki: 'molding',
    trackerEvent: {
      iconLabel: 'HOME_ABVFOLD_MOLDPROCESSICON_BTN_CLICK_',
      btnLabel: 'HOME_ABVFOLD_MOLDGETAQUOTE_BTN_CLICK_',
    },
    image: 'processes_injectionMolding.webp',
    id: 'PF-1e81bc3c07b6616ea0cdf45c89bf7ac9',
  },
]);

const exploreServiceProvider = () => {
  router.push({ name: 'LabsExploration' });
};
</script>
<template>
  <div id="#become-a-seller-main-container" class="become-seller-container">
    <HomepageGetListed />
    <HomepageWhyJoinAsServiceProvider />
    <HomepageProcessesGalerie :processes="processes" :is-mobile-device="settings.isMobileDevice" />
    <HomepageHowItWork />
    <HomepageExploreServiceProvider @explore-service-provider="exploreServiceProvider()" />
    <HomepageSocial />
    <HomepageBottomLinks :is-seller="true" />
    <Footer />
  </div>
</template>
<style lang="scss" scoped>
@use '/assets/scss/variables' as variables;

* {
  font-family: '3ds';
}

.become-seller-container :deep(.homepage-max-content-container) {
  width: 100%;
  max-width: 1500px;
  margin-left: auto;
  margin-right: auto;
}

.become-seller-container :deep(.title) {
  font-size: 34px;
  line-height: 34px;
  font-weight: 400;

  @include variables.for-mid {
    font-size: 28px;
    line-height: 28px;
  }
  @include variables.for-sm {
    font-size: 20px;
    line-height: 20px;
  }
}

.become-seller-container :deep(.text-content) {
  font-size: 16px;
  line-height: 20px;

  @include variables.for-mid {
    font-size: 15px;
    line-height: 20px;
  }
  @include variables.for-sm {
    font-size: 14px;
    line-height: 16px;
  }
}

.become-seller-container :deep(.subtitle) {
  font-size: 20px;
  line-height: 20px;
  font-weight: 300;

  @include variables.for-mid {
    font-size: 18px;
    line-height: 18px;
  }
  @include variables.for-sm {
    font-size: 16px;
    line-height: 16px;
  }
}
</style>
